import { RegularExpressions } from "../../../../../../Helpers/RegularExpression";
import { ValForm, ValFormReg } from "../../../../../../Validators/ValForms";

export const ValPedidoCondiciones = (state) => {
  const condiciones = ValFormReg(
    "Condiciones",
    state.condiciones,
    RegularExpressions.TextSpecialCharacter
  );
  const observaciones = ValFormReg(
    "Observaciones",
    state.observaciones,
    RegularExpressions.TextSpecialCharacter
  );
  const deposito = ValFormReg(
    "Deposito",
    state.deposito,
    RegularExpressions.TextOnlyNumber
  );
  const tasa = ValFormReg(
    "Tasa",
    state.tasa,
    RegularExpressions.TextOnlyNumber
  );
  // const mhusajdf = ValForm("Mhusa o JDF", state.mhusajdf);
  const gastos = ValFormReg(
    "Gastos y Seguro JDF",
    state.gastos,
    RegularExpressions.TextOnlyNumber
  );
  const anticipo = ValFormReg(
    "Anticipo Total",
    state.anticipo,
    RegularExpressions.TextOnlyNumber
  );
  const plazo = ValForm("Plazo", state.plazo);
  const enganche = ValFormReg(
    "Enganche JDF",
    state.enganche,
    RegularExpressions.TextOnlyNumber
  );
  var isValid = true;
  var mensaje = "";
  if (condiciones.isValid === false) {
    state.bcondiciones = true;
    isValid = false;
    mensaje += condiciones.mensaje;
  }
  if (observaciones.isValid === false) {
    state.bobservaciones = true;
    isValid = false;
    mensaje += observaciones.mensaje;
  }
  if (deposito.isValid === false) {
    state.bdeposito = true;
    isValid = false;
    mensaje += deposito.mensaje;
  }
  if (tasa.isValid === false) {
    state.btasa = true;
    isValid = false;
    mensaje += tasa.mensaje;
  }
  // if (mhusajdf.isValid === false) {
  //   state.bmhusajdf = true;
  //   isValid = false;
  //   mensaje += mhusajdf.mensaje;
  // }
  if (anticipo.isValid === false) {
    state.banticipo = true;
    isValid = false;
    mensaje += anticipo.mensaje;
  }
  if (plazo.isValid === false) {
    state.bplazo = true;
    isValid = false;
    mensaje += plazo.mensaje;
  }
  if (gastos.isValid === false) {
    state.bgastos = true;
    isValid = false;
    mensaje += gastos.mensaje;
  }
  if (enganche.isValid === false) {
    state.benganche = true;
    isValid = false;
    mensaje += enganche.mensaje;
  }

  if (isValid === false) {
    return { isValid, state, mensaje };
  } else {
    return {
      isValid,
      post: {
        folio: "",
        condiciones: state.condiciones,
        observaciones: state.observaciones,
        deposito: Number(state.deposito),
        taza: Number(state.tasa),
        mhusajdf: "",
        anticipo: Number(state.anticipo),
        plazo: state.plazo,
        tiempo_plazo: state.tiempo_plazo,
        gastos: 0, //Number(state.gastos),
        enganche: 0, // Number(state.enganche),
      },
    };
  }
};
